'use client';

import { parseUnits } from 'ethers/lib/utils';
import { ChainId, NATIVE_SOL } from '@shared/utils/config/networks';
import { fetchEVMTokenBalances } from '@shared/utils/evm/fetchEVMTokenBalance';
import { fetchSVMTokenBalances } from '@shared/utils/solana/base/fetchSVMTokenBalances';
import { isEVMNetwork } from '@shared/utils/validation/network-validation';
import buildAllPermit2Details from '@/lib/trade/buildAllPermit2Details';
export async function getQuoteAndTransferParams({
  tokenUserBalance,
  PKP,
  getEVMWallet,
  form,
  setParams,
  refetch,
  _formTokenAmount,
  _formSendTo,
  _formTokenUsdAmount
}) {
  var _a, _b, _c, _d, _e;
  _formTokenAmount = (_a = _formTokenAmount === null || _formTokenAmount === void 0 ? void 0 : _formTokenAmount.toString()) === null || _a === void 0 ? void 0 : _a.replace(',', '');
  let rawBalanceFlag = false;
  if (parseFloat(_formTokenAmount) > (tokenUserBalance === null || tokenUserBalance === void 0 ? void 0 : tokenUserBalance.formatted_balance) * 0.99) {
    let evmSVMBalances;
    if (tokenUserBalance.network != ChainId.SOLANA) {
      evmSVMBalances = await fetchEVMTokenBalances({
        network: tokenUserBalance.network,
        tokens: [tokenUserBalance.contract_address],
        owner: PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress
      });
    } else {
      evmSVMBalances = await fetchSVMTokenBalances({
        network: tokenUserBalance.network,
        tokens: [tokenUserBalance.contract_name == 'Solana' ? NATIVE_SOL : tokenUserBalance.contract_address],
        owner: PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress
      });
    }
    const rawBalance = evmSVMBalances[0].rawBalance;
    _formTokenAmount = rawBalance === null || rawBalance === void 0 ? void 0 : rawBalance.toString();
    rawBalanceFlag = true;
  }
  console.log('SendFunds: getQuoteAndTransferParams: init', _formTokenAmount, _formSendTo);
  try {
    if (!_formTokenAmount || isNaN(Number(_formTokenAmount))) {
      return;
    }
    let amount;
    if (rawBalanceFlag) {
      amount = _formTokenAmount;
    } else {
      try {
        amount = (_b = parseUnits(_formTokenAmount, tokenUserBalance.contract_decimals)) === null || _b === void 0 ? void 0 : _b.toString();
      } catch (_) {
        amount = (_e = parseUnits((_d = (_c = parseFloat(_formTokenAmount)) === null || _c === void 0 ? void 0 : _c.toFixed(tokenUserBalance.contract_decimals)) === null || _d === void 0 ? void 0 : _d.toString(), tokenUserBalance.contract_decimals)) === null || _e === void 0 ? void 0 : _e.toString();
      }
    }
    console.log('getQuote:amount', rawBalanceFlag, {
      p: parseFloat(_formTokenAmount),
      tokenUserBalance,
      amount
    }, _formSendTo);
    let permitBatchDetails = [];
    let permitSignatures = [];
    if (isEVMNetwork(tokenUserBalance.network)) {
      const result = await buildAllPermit2Details({
        tokensToApprove: [{
          network: tokenUserBalance.network,
          contract_address: tokenUserBalance.contract_address,
          amountToApprove: amount
        }],
        ethersPKPWallet: await getEVMWallet()
      });
      permitBatchDetails = result.permitBatchDetails;
      permitSignatures = result.permitSignatures;
    }
    const _transferParams = {
      token_address: tokenUserBalance.contract_address,
      token_amount: amount,
      network: tokenUserBalance.network,
      token_amount_formatted: parseFloat(amount) / 10 ** tokenUserBalance.contract_decimals,
      usd_value: parseFloat(_formTokenUsdAmount),
      decimals: tokenUserBalance.contract_decimals,
      symbol: tokenUserBalance.contract_ticker_symbol,
      name: tokenUserBalance.contract_name,
      image_thumb_url: tokenUserBalance.logo_url,
      image_small_url: tokenUserBalance.logo_url,
      image_large_url: tokenUserBalance.logo_url,
      from_address: tokenUserBalance.network == ChainId.SOLANA ? PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress : PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress,
      to_address: _formSendTo
    };
    const isNative = tokenUserBalance.network == ChainId.SOLANA && tokenUserBalance.contract_name == 'Solana';
    // // setTransferParams(transferParams);
    const _quoteParams = {
      network: tokenUserBalance.network,
      tokenAddress: isNative ? NATIVE_SOL : tokenUserBalance.contract_address,
      tokenAmount: amount,
      cloudWallet: tokenUserBalance.network == ChainId.SOLANA ? PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress : PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress,
      receiver: _formSendTo,
      permitBatchDetails,
      permitSignatures
    };
    form.setValue('transferParams', _transferParams);
    setParams(_quoteParams);
    refetch();
    console.log('getQuoteAndTransferParams:', {
      _transferParams,
      _quoteParams
    });
    // // setQuoteParams(_quoteParams);
    // return { _transferParams, _quoteParams };
    return;
  } catch (error) {
    console.log('getQuoteAndTransferParams:error', {
      error
    });
    // toast.warning('Error getting quotes!');
    // throw new Error(error);
  }
}